import axios from "axios";
const baseUrl = process.env.REACT_APP_API_URL;
const axiosInstance = axios.create({
  baseURL: baseUrl + "/api/v1",
});

axiosInstance.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("Manager-token");
  
  if (token) {
    config.headers["Authorization"] = "Bearer " + token;
  }
  return config;
});

export default axiosInstance;
